export default [
    {
      path: '/plans/washer/list',
      name: 'plans.washer.list',
      component: () => import('@/views/modules/plans/washer-plan/ListWasherPlan.vue'),
      meta: {
        module: 'plans.washer',
        pageTitle: 'Washer Plans',
        breadcrumb: [
          { text: 'Create Plan', to: { name: 'plans.washer.create' } },
        ],
      }
    },
  
  
    {
      path: '/plans/washer/create',
      name: 'plans.washer.create',
      component: () => import('@/views/modules/plans/washer-plan/CreateWasherPlan.vue'),
      meta: {
        module: 'plans.washer',
        pageTitle: 'Create Washer Plan',
        breadcrumb: [
          { text: 'List Plans', to: { name: 'plans.washer.list' } },
          { text: 'Create Washer Plan' , active: true}
        ],
      }
    },
  
  
    {
      path: '/plans/washer/:id/edit',
      name: 'plans.washer.edit',
      component: () => import('@/views/modules/plans/washer-plan/EditWasherPlan.vue'),
      meta: {
        module: 'plans.washer',
        pageTitle: 'Edit washer Plan',
        breadcrumb: [
          { text: 'List Plans', to: {name: 'plans.washer.list'} },
          { text: 'Edit Plan' , active: false},
        ],
      }
    },
  ]
  